import { render, staticRenderFns } from "./workloadOperation.vue?vue&type=template&id=6d904894"
import script from "./workloadOperation.vue?vue&type=script&lang=js"
export * from "./workloadOperation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports